import React, { useState } from 'react'
import { Editor, EditorState, RichUtils, Modifier } from 'draft-js'

import './style.css'
import { BlockStyleControls } from './BlockStyleControls'
import { InlineStyleControls } from './InlineStyleControls'
import { VariableControls } from './VariableControls'
import decorator from './decorator'

function RichEditor({
  defaultContent,
  onTextChange,
  variables,
  fieldName,
  isHeaderStyleHidden = false,
  hasParagraphSpacing = false,
}) {
  const createEmptyContent = () => EditorState.createEmpty(decorator)
  const [editorState, setEditorState] = useState(defaultContent || createEmptyContent())

  const onChange = (editorState) => {
    setEditorState(editorState)
    onTextChange(editorState)
  }

  function _toggleBlockType(blockType) {
    onChange(RichUtils.toggleBlockType(editorState, blockType))
  }

  function _toggleInlineStyle({ style: inlineStyle, link }) {
    onChange(RichUtils.toggleInlineStyle(editorState, inlineStyle))

    if (inlineStyle === 'LINK') {
      _addLink(link)
    }

    if (inlineStyle === 'UNLINK') {
      const hasLink = RichUtils.currentBlockContainsLink(editorState)
      if (hasLink) {
        _removeLink()
      }
    }
  }

  function _insertCharacter(characterToInsert) {
    const currentContent = editorState.getCurrentContent()
    const currentSelection = editorState.getSelection()
    const newContent = Modifier.replaceText(currentContent, currentSelection, characterToInsert)
    const newEditorState = EditorState.push(editorState, newContent, 'insert-characters')
    return EditorState.forceSelection(newEditorState, newContent.getSelectionAfter())
  }

  function _addVariable(value) {
    setEditorState(_insertCharacter(`{{ ${value} }}`))
  }

  function _addLink(link) {
    const contentState = editorState.getCurrentContent()
    const contentStateWithEntity = contentState.createEntity('LINK', 'MUTABLE', {
      url: link,
    })
    const entityKey = contentStateWithEntity.getLastCreatedEntityKey()
    const newEditorState = EditorState.set(editorState, {
      currentContent: contentStateWithEntity,
    })

    onChange(RichUtils.toggleLink(newEditorState, newEditorState.getSelection(), entityKey))
  }

  function _removeLink() {
    const selection = editorState.getSelection()
    onChange(RichUtils.toggleLink(editorState, selection, null))
  }

  const _handleKeyCommand = (command) => {
    const newState = RichUtils.handleKeyCommand(editorState, command)
    if (newState) {
      onChange(newState)
    }

    return newState
  }

  return (
    <div
      className={
        hasParagraphSpacing ? 'richeditor-root richeditor-root--paragraph-spacing' : 'richeditor-root'
      }
    >
      <div className="field">
        <label>
          {fieldName}
          <span className="float-right">
            {!isHeaderStyleHidden && (
              <BlockStyleControls editorState={editorState} onToggle={_toggleBlockType} />
            )}
            <InlineStyleControls editorState={editorState} onToggle={_toggleInlineStyle} />
            <VariableControls onSelect={_addVariable} variables={variables} />
          </span>
        </label>
        <div className="richeditor-editor">
          <Editor
            editorState={editorState}
            handleKeyCommand={_handleKeyCommand}
            onChange={onChange}
            spellCheck
            data-gramm="false"
            stripPastedStyles
          />
        </div>
      </div>
    </div>
  )
}

export default RichEditor

export const getEmptyContentState = () => EditorState.createEmpty(decorator)



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/RichEditor/index.js